import { Component, OnInit } from '@angular/core';
import { PeopleSyncService } from '../services/peoplesync.service';

interface TrackingRecord {
  started_at: string;
  ended_at: string;
  row_count: number;
  endpoint_version: string;
}

interface ErrorRecord {
  time: string;
  error: string;
  endpoint_version: string;
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(private _ps: PeopleSyncService) { }

  options = [
    { value: 'Name', label: 'Name', description: 'Search by Name' },
    { value: 'GMID', label: 'GMID', description: 'Search by GMID' },
    { value: 'Exact Name', label: 'Exact Name', description: 'Search by Exact Name' }
  ];

  selectedOption: string = '';
  descriptionText: string = 'Please select an option.';
  isSearchEnabled: boolean = false;
  searchQuery: string = '';
  trackingData: TrackingRecord[] = [];
  isLoadingTracking: boolean = false;
  errorData: ErrorRecord[] = [];
  isLoadingErrors: boolean = false;

  ngOnInit() {
    this.loadTrackingData();
    this.loadErrorData();
  }

  loadTrackingData() {
    this.isLoadingTracking = true;
    this._ps.getUpdateTracking().subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : [res];
        // Sort by started_at date, most recent first
        this.trackingData = data.sort((a: TrackingRecord, b: TrackingRecord) => {
          return new Date(b.started_at).getTime() - new Date(a.started_at).getTime();
        });
        this.isLoadingTracking = false;
        console.log('Tracking data:', this.trackingData);
      },
      error: (err: any) => {
        console.error('Error loading tracking data:', err);
        this.isLoadingTracking = false;
      }
    });
  }

  loadErrorData() {
    this.isLoadingErrors = true;
    this._ps.getErrorTracking().subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : [res];
        // Sort by time, most recent first
        this.errorData = data.sort((a: ErrorRecord, b: ErrorRecord) => {
          return new Date(b.time).getTime() - new Date(a.time).getTime();
        });
        this.isLoadingErrors = false;
        console.log('Error data:', this.errorData);
      },
      error: (err: any) => {
        console.error('Error loading error tracking data:', err);
        this.isLoadingErrors = false;
      }
    });
  }

  onOptionChange() {
    const selected = this.options.find(option => option.value === this.selectedOption);
    this.descriptionText = selected ? selected.description : 'Please select an option.';
    this.isSearchEnabled = !!selected;
  }

  onSearch() {
    console.log('Search query:', this.searchQuery);
    // Add your search logic here
    switch (this.selectedOption) {
      case 'Name':
        this._ps.getPeopleByName(this.searchQuery).subscribe((res: any) => {
          console.log('Search results:', res);
        });
        break;
      case 'GMID':
        this._ps.getPeopleByGMID(this.searchQuery).subscribe((res: any) => {
          console.log('Search results:', res);
        });
        break;
      case 'Exact Name':
        this._ps.getPeopleByExactName(this.searchQuery).subscribe((res: any) => {
          console.log('Search results:', res);
        });
        break;
      default:
        console.error('Invalid search option selected.');
    }
  }
}
